import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import clsx from 'clsx'
import { sanitizeFieldName } from '@/utils/sanitizedLabel'

type Props = {
	id: string
	placeholder?: string
	required: boolean
	label: string
	colSpan?: string
	formStyle: string
	register: UseFormRegister<any>
	errors: FieldErrors
	className?: string
}

export default function Textarea({
	id,
	required,
	label,
	colSpan = '1',
	formStyle,
	register,
	errors,
	className,
}: Readonly<Props>) {
	const fieldName = sanitizeFieldName(label)
	return (
		<div
			className={clsx(
				'form-component',
				{
					'2': 'colSpan2',
				}[colSpan],
				className
			)}
		>
			<div
				className={clsx('form-element-container', formStyle === 'line' && 'line-style')}
				onClick={() => document.getElementById(id)?.focus()}
			>
				<textarea
					id={id}
					className="textarea"
					placeholder={''}
					{...register(fieldName, {
						required: {
							value: required,
							message: `${label} is required`,
						},
					})}
				/>
			</div>
			<label htmlFor={id}>{`${label} ${required ? '*' : ''}`}</label>
			{errors && errors[fieldName] && (
				<span className="mt-1 text-red-500">
					{errors[fieldName]?.type === 'required'
						? `${label} is required`
						: errors[fieldName]?.message?.toString()}
				</span>
			)}
		</div>
	)
}
